export default __webpack_public_path__ + "static/media/upload.531d4758.png";